import { Box, BoxProps, ButtonNew, ColorOptions, Text, TextProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { pages } from '../../../utils/constants'

interface TopAddNewContainerProps {
  theme: any
  totalAvaliableCard: number
  type: string
}

export const TopAddNewContainer = ({ theme, totalAvaliableCard, type }: TopAddNewContainerProps) => {
  const { navigate } = useNavigation()
  return (
    <Box {...styles.topContainer}>
      <Text
        {...styles.totalCardText}
        color={theme?.bodyTextColor as ColorOptions}>{`Cards eligible for EMI (${totalAvaliableCard})`}</Text>
      <ButtonNew
        onPress={() => {
          navigate(pages.emicard, { schemeSubType: type === 'CREDITCARD' ? '00' : '01' })
        }}
        title="+ Add New"
        testID="add-new"
        color={theme?.bodyBgColor as ColorOptions}
        type={'tertiary'}
        textType="body14"
        titleColor={theme?.brandColor as ColorOptions}
      />
    </Box>
  )
}

const styles = {
  topContainer: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingHorizontal: 24,
    alignItems: 'center',
    marginVertical: 12,
  } as BoxProps,
  totalCardText: {
    fontSize: 14,
    fontFamily: 'jioType-medium',
  } as TextProps,
}
